var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline"},[_c('NEIcon',{attrs:{"label":"Check Notification","color":'gray',"badge":_vm.node.badge,"img":require('../img/bell.svg')},on:{"click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }